import React, { Component } from 'react';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu/modules";
import { Container, Draggable } from 'react-smooth-dnd'
import InlineEdit from './InlineEdit';
import { Maybe } from 'flowr';

class MenuNode extends Component {
  onDragStart(payload) {


  }
  onDragEnd(payload) {
    return;
  }
  shouldAcceptDrop(sourceContainerOptions) {
    return false;
  }
  render() {

    const { label, id, handlePeer, handleAdd, handleDelete, dataChanged, handleDnD, depth, treeLength, validatioFunction, status } = this.props;

    function dragover_handler(ev, data) {
      if (status != 0)
        return;
      ev.preventDefault();
      ev.dataTransfer.dropEffect = "copy"
    }



    let data = {
      id: id,
      name: label,
      draggableType: 'TeamMapping'
    }

    return (
      <div>
        <Maybe when={!true}>
          <ContextMenu id={`contextMenu_${id}`}>
            <Maybe when={depth < 1}>
              <MenuItem data={{ id }} onClick={handlePeer}>
                Add Phase
              </MenuItem>
            </Maybe>
            <Maybe when={depth < 1}>
              <MenuItem data={{ id }} onClick={handleAdd}>
                Add Stage
              </MenuItem>
            </Maybe>
            <Maybe when={treeLength != 1 || depth > 0}>
              <MenuItem data={{ id }} onClick={handleDelete}>
                Remove Element
              </MenuItem>
            </Maybe>
          </ContextMenu>
        </Maybe>

        {id &&
          <ContextMenuTrigger id={`contextMenu_${id}`} holdToDisplay={-1} >
            <Container onDragStart={this.onDragStart} onDragLeave={this.onDragEnd} groupName={!this.props.parentCommunity ? 'TeamCreation' : 'TeamMapping'} behaviour="copy" shouldAcceptDrop={this.shouldAcceptDrop} getChildPayload={i => { return data; }} style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px" }}>
              <Draggable className={`well  ${this.props.setUniqueId === id.toString() ? "setActiveLabel" : ""} `} id={id.toString()} >
                <InlineEdit
                  activeClassName="editing"
                  text={label}
                  colorTag={depth > 0 ? this.props.colorTag : ""}
                  paramName="message"
                  data={{ id }}
                  change={dataChanged}
                  validationFunction={validatioFunction}
                  status={status}
                  isDisabled={true}
                  parentCommunity={this.props.parentCommunity}
                  associatedTeam={this.props.associatedTeam}
                  style={{
                    minWidth: 100,
                    maxWidth: 200,
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    display: 'block',
                    margin: 0,
                    padding: 5,
                    fontSize: 'inherit',
                    outline: 0,
                    borderLeft: "4px solid " + this.props.colorTag,

                  }}
                />

              </Draggable>
            </Container>
          </ContextMenuTrigger>
        }
      </div>
    );
  };
}

export default MenuNode;